import React from 'react';
import { Stack, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {
  TypographySmallTitle,
  SectionContainer,
  ValueTypography,
  NotAssignedTypography,
} from './DocumentDetailsLeft';
import { IDocumentUnscoped } from '../../../types/my-types';
import SetVendor from './SetVendor';

interface IVendorNameProps {
  documentData: IDocumentUnscoped;
}

const VendorName: React.FC<IVendorNameProps> = ({ documentData }) => {
  return (
    <SectionContainer>
      <TypographySmallTitle sx={{ marginBottom: '5px' }}>VENDOR NAME</TypographySmallTitle>

      {documentData.vendor ? (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <ValueTypography data-cy="text-vendor-name">{documentData.vendor_name}</ValueTypography>
          <SetVendor documentId={documentData.id} currentVendorId={documentData.vendor} />
        </Stack>
      ) : (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={0.5} alignItems="center">
            <WarningIcon sx={{ color: 'orange', fontSize: 'small' }} />
            <NotAssignedTypography data-cy="vendor-name-not-assigned">
              Not Assigned
            </NotAssignedTypography>
          </Stack>
          <SetVendor documentId={documentData.id} currentVendorId={null} />
        </Stack>
      )}
    </SectionContainer>
  );
};

export default VendorName;
